import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Gift, ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ZOLA_REGISTRY_URL = 'https://www.zola.com/registry/adrienneandthomasseptember5';

export const Registry = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section ref={ref} className="py-20 bg-[#EFF4F9]" data-testid="registry-section">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}>
          <Gift className="w-8 h-8 text-[#C9A96E] mx-auto mb-4" strokeWidth={1.5} />
          <h2 className="font-serif text-4xl sm:text-5xl text-[#1A2B3D] mb-4">{t('registry')}</h2>
          <div className="wave-divider mb-6" />
          <p className="text-[#6B8299] leading-relaxed mb-2">{t('registryDesc')}</p>
          <p className="text-[#6B8299] leading-relaxed mb-8">{t('registryDesc2')}</p>

          <a href={ZOLA_REGISTRY_URL} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#1E3A5F] text-white text-sm px-8 py-3 rounded hover:bg-[#2C5F7C] transition-colors"
            data-testid="registry-visit-button">
            {t('registryButton')} <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
